export const CajaFields = (data, origen) => {
  return [
    {
      label: 'Origen',
      class: 'textfield',
      value: origen,
      sm: 2,
      xs: 12,
      disabled: true,
    },
    {
      label: origen === 'ECO' ? 'Punto de venta' : 'Sucursal',
      class: 'textfield',
      value: origen === 'ECO' ? `${data.punto_venta} (${data.sucursal})` : data.sucursal,
      sm: 3,
      xs: 12,
      disabled: true,
    },
  ]
}
